import Vue from 'vue'
import axios from 'axios';
import {CONFIG} from './config.js';


const Login = Vue.component('login', {
    data: function() {
        return {
            username: null,
            password: null
        }
    },
    methods: {
        login: function() {
            var self = this;

            this.$store.commit('setToken', null);
            this.$store.commit('setTokenExpiresIn', null);

            this.$request("post", CONFIG.api.endpoints.token,
                function(response) {
                    var token = response.data[0]["token"];
                    self.$store.commit('setToken', token);
                    self.$store.commit('setTokenExpiresIn', Date.now() + CONFIG.api.tokenExpiration);

                    var path = self.$store.state.tokenExpiredBackwardRoute || CONFIG.afterLoginRoute;
                    self.$router.push({ path: path });
                },
                {
                    data:
                    {
                        "login_": this.username,
                        "domain_": CONFIG.tokenDomain,
                        "password_": this.password
                    }
                }
            )
        },
        forgottenPassword: function() {
            this.$router.push({path: "/forgottenPassword/"})
        },
    },
    template: '#login'
})

export default Login;